import { render, staticRenderFns } from "./html.vue?vue&type=template&id=4f60887a"
import script from "./html.vue?vue&type=script&lang=js"
export * from "./html.vue?vue&type=script&lang=js"
import style0 from "./html.vue?vue&type=style&index=0&id=4f60887a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports